import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DstRolloverModalService {

  constructor(private http: HttpClient) {}

  /**
   * Parity with legacy DSTrollOverFactory.dstRollOver: the action code lives on
   * the URL and sso_id / tax_year are sent as query params, with no body.
   */
  triggerRollover(baseUrl: string, ssoId: string, taxYear: any): Observable<any> {
    let params = new HttpParams().set('action_code', 'i1300q');

    if (ssoId) {
      params = params.set('sso_id', String(ssoId));
    }
    if (taxYear !== undefined && taxYear !== null && taxYear !== '') {
      params = params.set('tax_year', String(taxYear));
    }

    return this.http.post<any>(`${baseUrl}/saveJsonObject`, null, {
      params,
      withCredentials: true
    });
  }
}
